import { Badge, Space } from "antd";
import { Button } from "antd";
import { EditOutlined, EyeOutlined } from "@ant-design/icons";

import { docLinkRender } from "../../../components/table/DocLink";
export const accessColumn = ({ handleView, handleEdit }) => [
  {
    title: "id",
    key: "id",
    dataIndex: "id",
    align: "left",
    hidden: true,
  },
  {
    title: "Indirect Material Code",
    dataIndex: "im_code",
    key: "im_code",
    width: "40%",
    sorter: (a, b) => (a?.im_code || "").localeCompare(b?.im_code || ""),
    /* กดเลขที่เอกสารเพื่อเปิดหน้าแสดงข้อมูล */
    render: docLinkRender(handleView, "เปิดดูข้อมูลวัสดุ"),
  },
  {
    title: "Indirect Material Name",
    dataIndex: "im_name",
    key: "im_name",
    width: "40%",
    sorter: (a, b) => (a?.im_name || "").localeCompare(b?.im_name || ""),
  },
  {
    title: "สถานะ",
    dataIndex: "active_status",
    key: "active_status",
    width: "20%",
    sorter: (a, b) =>
      (a?.active_status || "").localeCompare(b?.active_status || ""),
    render: (data) => (
      <div>
        {data === "เปิดการใช้งาน" ? (
          <Badge status="success" text="เปิดการใช้งาน" />
        ) : (
          <Badge status="error" text="ปิดการใช้การ" />
        )}
      </div>
    ),
  },
  {
    title: "Action",
    key: "operation",
    width: 140,
    fixed: "right",
    render: (text, record) => (
      <Space>
        <Button
          size="small"
          icon={<EyeOutlined />}
          className="bn-success-outline"
          title="ดูข้อมูล"
          onClick={() => handleView(record)}
        />
        <Button
          icon={<EditOutlined />}
          className="bn-primary-outline"
          style={{
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          onClick={(e) => handleEdit(record)}
          size="small"
        />
      </Space>
    ),
  },
];

/* ค่าเริ่มต้นของฟอร์ม — ฟิลด์ชุดเดียวกับ Raw Material */
export const immaster = {
  id: null,
  im_code: null,
  im_name: null,
  im_nameEN: null,
  express_name: null,
  purchase_name: null,
  unit: null,
  min_stock: null,
  remark: null,
  active_status: "เปิดการใช้งาน",
};
